import { RATIO_PLAN_METRICES } from "@/ts/constants";
import { internationalizeNumericValue, titleCase } from "@/ts/utils";
import { Card } from "antd";
import {
    CheckCircleTwoTone,
    ExclamationCircleTwoTone,
} from "@ant-design/icons";
import React from "react";
import { CardTitles } from "@/ts/common-types";

export type TAchievedCardProps = {
    metric: string;
    targetAchieved: number;
    targetAchievedPerc: number;
    targetSet: number;
};

const TargetAchievedCard: React.FC<TAchievedCardProps> = ({
    metric,
    targetAchieved,
    targetAchievedPerc,
    targetSet,
}) => {
    const isRatioMetric = RATIO_PLAN_METRICES.includes(metric);
    const isMetricTargetMet = isRatioMetric
        ? targetAchieved >= targetSet
        : targetAchievedPerc >= 100;

    const textColor = isMetricTargetMet ? "#005700" : "#8E1616";

    return (
        <Card
            style={{
                borderRadius: "10px",
                padding: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
            }}
            title={
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        fontSize: "1.5rem",
                        fontWeight: 600,
                    }}
                >
                    {CardTitles[metric as keyof typeof CardTitles]}
                    {isMetricTargetMet ? (
                        <CheckCircleTwoTone
                            twoToneColor={["#34D399", "#059669"]}
                            style={{ fontSize: "1.5rem" }}
                        />
                    ) : (
                        <ExclamationCircleTwoTone
                            twoToneColor={["#FF6B6B", "#D90429"]}
                            style={{ fontSize: "1.5rem" }}
                        />
                    )}
                </div>
            }
            className="compact-card w-60 mx-2"
        >
            <div
                style={{
                    fontSize: "1.7rem",
                    fontWeight: 700,
                    color: textColor,
                }}
            >
                {isRatioMetric ? targetAchieved : `${targetAchievedPerc}%`}
            </div>
            <div style={{ fontSize: "1.2rem", margin: "4px 0", color: "grey" }}>
                Target:{" "}
                <strong>{internationalizeNumericValue(targetSet)}</strong>
            </div>
        </Card>
    );
};

export default TargetAchievedCard;
